import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullValue'
})
export class NullValuePipe implements PipeTransform {

  transform(value: null | any): unknown {
    return value === null && '-' || value;
  }

}
